import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import { configure } from 'mobx';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.scss';
import './colors.scss';
import './dimensions.scss';
import './misc.scss';
import { InitValues } from './core/consts';
import * as Sentry from '@sentry/browser';
// Service worker is now registered via register-sw.js in public folder
import { config } from './core/config/config';

// Disable MobX strict mode
configure({
  enforceActions: 'never',
});

const CityStreamApp = React.lazy(() => import('./CityStreamApp'));
const StreetsApp = React.lazy(() => import('./StreetsApp'));
const LiveApp = React.lazy(() => import('./LiveApp'));

window.onload = () => {
  InitValues();

  mapboxgl.accessToken = config.MAPBOX_ACCESS_TOKEN;
  mapboxgl.setRTLTextPlugin(
    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
    null,
    true // Lazy load the plugin
  );

  const App =
    process.env.REACT_APP_STREETS_BUILD === 'true'
      ? StreetsApp
      : process.env.REACT_APP_LIVE_BUILD === 'true'
      ? LiveApp
      : CityStreamApp;

  if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: config.SENTRY_ENV,
    });
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');
  const root = createRoot(rootElement);
  root.render(
    <Suspense fallback={null}>
      <App />
    </Suspense>
  );
};

// Service worker is now registered via register-sw.js in public folder
